<script>
import { mapActions, mapGetters, mapState } from "vuex";

import Loader from "@/components/_base/Loader";

import scheduleEventMixin from "@/mixins/scheduleEventMixin";
import dateMixin from "@/mixins/dateMixin";

export default {
  mixins: [scheduleEventMixin, dateMixin],

  components: {
    Loader
  },

  methods: {
    ...mapActions("orderScheduler", [
      "setScheduleEvent",
      "setInitialHour",
      "setDuration"
    ]),

    schedulePeriod(event) {
      const period = this.$options.filters.period(event);

      if (!period) {
        return;
      }

      return `entre ${period[0]}h e ${period[1]}h`;
    },

    sameDate(event) {
      return this.date && this.matchDate(this.date, event.starts_at);
    },

    insideSchedulePeriod(event) {
      if (!this.initialHour) {
        return;
      }

      const period = this.$options.filters.period(event);

      if (!period) {
        return;
      }

      if (this.duration) {
        return (
          this.initialHour >= period[0] &&
          this.initialHour + this.duration <= period[1]
        );
      }

      return this.initialHour >= period[0] && this.initialHour < period[1];
    },

    supportDuration(event) {
      if (!this.duration) {
        return;
      }

      const period = this.$options.filters.period(event);

      if (!period) {
        return;
      }

      return this.duration <= period[1] - period[0];
    },

    handleSetScheduleEvent(event) {
      this.setScheduleEvent(event);

      this.$emit("dateSelected");
    },

    noValidEvents() {
      return (
        !this.scheduleEvents ||
        this.scheduleEvents.length === 0 ||
        this.scheduleEvents.filter(event => this.schedulePeriod(event))
          .length === 0
      );
    }
  },

  computed: {
    ...mapState("orderScheduler", [
      "scheduleEventId",
      "scheduleEvents",
      "scheduleEventsPreloader"
    ]),
    ...mapGetters("orderScheduler", [
      "date",
      "initialHour",
      "duration",
      "missingRequiredFields"
    ])
  }
};
</script>

<template>
  <div class="root">
    <div class="schedules">
      <div class="loader" v-if="scheduleEventsPreloader">
        <Loader />
        <p>{{ missingRequiredFields ? "Buscando a agenda do profissional..." : 'Confirmando horario na agenda do profissional...' }}</p>
      </div>

      <div class="empty" v-else-if='noValidEvents()'>
        Ops, parece que esse profissional não possui mais horários disponíveis.
      </div>

      <template v-else v-for="event in scheduleEvents">
        <div
          class="schedule"
          :class="{ 'selected': event.id === scheduleEventId }"
          v-if="schedulePeriod(event)"
          :key="event.id"
          @click="handleSetScheduleEvent(event)"
        >
          <span class="day">
            {{ event | day }}
          </span>

          <span class="weekday">
            {{ event.starts_at | weekday }}
          </span>

          <span class="period">
            {{ schedulePeriod(event) }}
          </span>

          <div class="icons">
            <img v-if="sameDate(event)" src="/static/calendar-outlined.svg" />
            <img v-if="initialHour && insideSchedulePeriod(event)" src="/static/clock-outlined.svg" />
            <img v-if="duration && supportDuration(event)" src="/static/stopwatch-outlined.svg" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.empty {
  font-weight: 400;
  text-align: center;
}

.schedules {
  display: flex;
  flex-direction: row;
  grid-gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.schedule {
  width: 90px;
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  border: solid 1px #e2e2e2;
  border-radius: 2px;
  text-align: center;
  transition: border 250ms ease-in-out, background 250ms ease-in-out;
  cursor: pointer;
}

.schedule:hover,
.selected {
  border-color: #603285;
  border-width: 2px;
}

.schedule span:not(:first-child) {
  margin-top: 4px;
}

.day {
  font-size: 14px;
  font-weight: 400;
  color: #603285;
}

.weekday {
  font-size: 12px;
  color: #603285;
}

.period {
  font-size: 12px;
  color: #af006b;
}

.icons {
  position: absolute;
  top: -8px;
  right: 4px;
  background: #fff;
}

img {
  width: 12px;
  height: 12px;
}

@media (max-width: 375px) {
  .schedules {
    grid-gap: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalFilters/ScheduleEvents.vue